import dayjs from "dayjs";

export function formatDateTime(date) {
    return dayjs(date).isValid ? dayjs(date)?.format("DD MMM YYYY hh:mm A") : `${date}`;
}